/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Empty/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import AddAction from './AddAction/index'
import EnableAction from './EnableAction/index'
import React from 'react'
import SystemAutomation from './SystemAutomation/index'
import TysiaCard from 'DesignSystem/TysiaCard/index'
import TysiaCardContent from 'DesignSystem/TysiaCard/TysiaCardContent/index'
import TysiaIconSettings from 'DesignSystem/Svgs/TysiaIconSettings/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Empty({
  children,
  viewPath = "/App/Account/Content/Settings/AdminContent/SettingsContent/TreatmentAutomations/AutomationsList/EnableAutomationHub/Empty"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtColorsBlue800 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.blue.800'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let systemAutomationsValueData = fromData.useDataValue({ viewPath,
context: 'system_automations',
})
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<div
  data-testid="Empty.Vertical"
  data-view-path={viewPath}
 style={{'--mb-1-4PwO0': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Empty.Horizontal"
  data-view-path={viewPath}
 style={{'--mb-1-4PwO0': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<EnableAction
  viewPath={`${viewPath}/EnableAction`}
/>
<AddAction
  viewPath={`${viewPath}/AddAction`}
/>
</div>
<TysiaCard
  viewPath={`${viewPath}/TysiaCard`}
 width="100%"
 flexDirection="column"
 borderColor={dtColorsNeutral200}
>
{childProps => (
<TysiaCardContent
{...childProps}
  viewPath={`${viewPath}/TysiaCardContent`}
 paddingTop={dtSpaceM}
>
{childProps => (
<React.Fragment>
<div
  data-testid="Empty.Horizontal:1"
  data-view-path={viewPath}
 style={{'--mb-1-4PwO0': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaIconSettings
  viewPath={`${viewPath}/TysiaIconSettings`}
 height={18}
 width={18}
 fill={dtColorsBlue800}
 marginRight={dtSpaceXxs}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 size="xmedium"
 text="Enabling this feature will disable the in-built system automations described below 👇 and you can no longer go back to your previous settings."
/>
</div>
<div
  data-testid="Empty.List"
  data-view-path={viewPath}
 className="views-block"
>
{Array.isArray(systemAutomationsValueData) && systemAutomationsValueData.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="system_automation"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/SystemAutomation(${item?.id ?? item?._id ?? index})`}
      >
<SystemAutomation
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/SystemAutomation(${item?.id ?? item?._id ?? index})`}
/>
</ListItem>
)}
</div>
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 text="Please reach out to the Support Team if you have any concerns or questions."
 fontWeight="regular"
 size="xmedium"
 color={dtColorsNeutral500}
 marginTop={dtSpaceS}
/>
</React.Fragment>
)}
</TysiaCardContent>
)}
</TysiaCard>
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }